import { create } from 'zustand';

interface UIState {
  reportModalOpen: boolean;
  authModalOpen: boolean;
  premiumModalOpen: boolean;
  sidebarOpen: boolean;
  toasts: Toast[];

  openReportModal: () => void;
  closeReportModal: () => void;
  openAuthModal: () => void;
  closeAuthModal: () => void;
  openPremiumModal: () => void;
  closePremiumModal: () => void;
  toggleSidebar: () => void;
  addToast: (toast: Omit<Toast, 'id'>) => void;
  removeToast: (id: string) => void;
}

interface Toast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

export const useUIStore = create<UIState>((set) => ({
  reportModalOpen: false,
  authModalOpen: false,
  premiumModalOpen: false,
  sidebarOpen: false,
  toasts: [],

  openReportModal: () => set({ reportModalOpen: true }),
  closeReportModal: () => set({ reportModalOpen: false }),
  openAuthModal: () => set({ authModalOpen: true }),
  closeAuthModal: () => set({ authModalOpen: false }),
  openPremiumModal: () => set({ premiumModalOpen: true }),
  closePremiumModal: () => set({ premiumModalOpen: false }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),

  addToast: (toast) =>
    set((state) => ({
      toasts: [
        ...state.toasts,
        { ...toast, id: `toast-${Date.now()}-${Math.random()}` },
      ],
    })),

  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));
